(() => {
  if (window.__svPersistNav) return;
  window.__svPersistNav = true;

  const HARD_NAV_RE = /\/(cart|checkout|account|checkouts)(\/|$)/i;
  const loadedScriptSrcs = new Set(
    [...document.querySelectorAll('script[src]')].map((s) => s.src)
  );
  const loadedStyleHrefs = new Set(
    [...document.querySelectorAll('link[rel="stylesheet"]')].map((s) => s.href)
  );
  const loadedStyleIds = new Set(
    [...document.querySelectorAll('style[id]')].map((s) => s.id)
  );
  let inFlight = false;

  const LENIS_CSS_URL =
    'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.css';
  const LENIS_JS_URL =
    'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.min.js';

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function shouldIntercept(anchor, event) {
    if (isDesignMode()) return false;
    if (!anchor || !anchor.href) return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '' && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (e) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    if (HARD_NAV_RE.test(url.pathname)) return false;
    if (anchor.hasAttribute('data-search-toggle')) return false;
    if (/\/search\/?$/.test(url.pathname) && !url.search) return false;

    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }

    return true;
  }

  function getScrollRoot() {
    return document.querySelector('#smooth-wrapper') || window;
  }

  function resetScroll() {
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(0, { immediate: true });
    }

    const root = getScrollRoot();
    if (root === window) {
      window.scrollTo(0, 0);
    } else {
      root.scrollTop = 0;
      window.scrollTo(0, 0);
    }

    if (typeof ScrollTrigger !== 'undefined') {
      try {
        ScrollTrigger.refresh();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function hasActiveBorders() {
    return Boolean(
      document.querySelector('.scroll-borders[data-borders-active="true"]')
    );
  }

  function waitForLenis(maxMs) {
    return new Promise((resolve) => {
      if (typeof window.Lenis !== 'undefined') {
        resolve();
        return;
      }
      const start = Date.now();
      const tick = () => {
        if (typeof window.Lenis !== 'undefined') {
          resolve();
          return;
        }
        if (Date.now() - start >= maxMs) {
          resolve();
          return;
        }
        setTimeout(tick, 25);
      };
      tick();
    });
  }

  async function ensureLenisAssets() {
    await injectStylesheet(LENIS_CSS_URL, null);

    if (typeof window.Lenis !== 'undefined') return;

    let jsHref;
    try {
      jsHref = new URL(LENIS_JS_URL, window.location.origin).href;
    } catch (e) {
      return;
    }

    if (!loadedScriptSrcs.has(jsHref)) {
      loadedScriptSrcs.add(jsHref);
      try {
        await injectScript(jsHref, false);
      } catch (e) {
        window.debugLog('[sv-persist-nav] Lenis script failed', e);
      }
    }

    await waitForLenis(8000);
  }

  function needsLenisForPage() {
    return (
      hasActiveBorders() ||
      Boolean(document.querySelector('[data-image-banner-scroll-scale]'))
    );
  }

  async function syncLenisForPage() {
    if (needsLenisForPage()) {
      await ensureLenisAssets();
      if (typeof window.svInitLenisSmoothScroll === 'function') {
        window.svInitLenisSmoothScroll();
      }
      return;
    }

    if (
      window.lenis &&
      typeof window.svDestroyLenisSmoothScroll === 'function'
    ) {
      window.svDestroyLenisSmoothScroll();
    }
  }

  function destroyAlpine(el) {
    if (el && window.Alpine && typeof Alpine.destroyTree === 'function') {
      Alpine.destroyTree(el);
    }
  }

  function initAlpine(el) {
    if (el && window.Alpine && typeof Alpine.initTree === 'function') {
      Alpine.initTree(el);
    }
  }

  function findFooter(doc) {
    return (
      doc.querySelector('.shopify-section-group-footer-group') ||
      doc.querySelector('[id^="shopify-section-sections--"][id*="footer"]')
    );
  }

  function swapHero(doc) {
    const current = document.querySelector('#heroGroupWrapper');
    const next = doc.querySelector('#heroGroupWrapper');
    const main = document.querySelector('#MainContent');

    if (current && next) {
      destroyAlpine(current);
      current.replaceWith(next.cloneNode(true));
      return;
    }

    if (current && !next) {
      destroyAlpine(current);
      current.remove();
      return;
    }

    if (!current && next && main) {
      main.parentNode.insertBefore(next.cloneNode(true), main);
    }
  }

  function swapMain(doc) {
    const current = document.querySelector('#MainContent');
    const next = doc.querySelector('#MainContent');
    if (!current || !next) return false;

    destroyAlpine(current);
    current.innerHTML = next.innerHTML;
    return true;
  }

  function swapFooter(doc) {
    const current = findFooter(document);
    const next = findFooter(doc);
    if (!current || !next) return;

    destroyAlpine(current);
    current.replaceWith(next.cloneNode(true));
  }

  function swapSidebarLogo(doc) {
    const current = document.querySelector('.sv-sidebar-logo');
    const next = doc.querySelector('.sv-sidebar-logo');
    if (!current || !next) return;
    current.replaceWith(next.cloneNode(true));
  }

  function injectStylesheet(href, media) {
    return new Promise((resolve) => {
      if (!href) {
        resolve();
        return;
      }

      const existing = [...document.querySelectorAll('link[rel="stylesheet"]')].some(
        (link) => {
          try {
            return new URL(link.href, window.location.origin).href === href;
          } catch (e) {
            return false;
          }
        }
      );

      if (existing) {
        loadedStyleHrefs.add(href);
        resolve();
        return;
      }

      loadedStyleHrefs.add(href);
      const el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = href;
      if (media) el.media = media;
      el.onload = () => resolve();
      el.onerror = () => resolve();
      document.head.appendChild(el);
    });
  }

  function adoptHeadStyles(doc) {
    const tasks = [];

    doc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      let href;
      try {
        href = new URL(link.getAttribute('href'), window.location.origin).href;
      } catch (e) {
        return;
      }
      tasks.push(injectStylesheet(href, link.getAttribute('media')));
    });

    doc.querySelectorAll('head style').forEach((style) => {
      const key =
        style.id ||
        `txt:${style.textContent.length}:${style.textContent.slice(0, 120)}`;
      if (loadedStyleIds.has(key)) return;
      if (style.id && document.getElementById(style.id)) {
        loadedStyleIds.add(key);
        return;
      }
      loadedStyleIds.add(key);
      document.head.appendChild(style.cloneNode(true));
    });

    return Promise.all(tasks);
  }

  function promoteBodyStylesheets(root) {
    if (!root) return Promise.resolve();

    const tasks = [];
    root.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      let href;
      try {
        href = new URL(link.getAttribute('href'), window.location.origin).href;
      } catch (e) {
        link.remove();
        return;
      }
      const media = link.getAttribute('media');
      link.remove();
      tasks.push(injectStylesheet(href, media));
    });

    return Promise.all(tasks);
  }

  function refreshMedia(root) {
    if (!root) return;

    root.querySelectorAll('img').forEach((img) => {
      if (img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
      }
      if (img.dataset.src && !img.getAttribute('src')) {
        img.setAttribute('src', img.dataset.src);
      }
      if (img.dataset.srcset && !img.getAttribute('srcset')) {
        img.setAttribute('srcset', img.dataset.srcset);
      }
      try {
        if (typeof img.decode === 'function') img.decode().catch(() => {});
      } catch (e) {}
    });

    root.querySelectorAll('source[data-srcset]').forEach((source) => {
      if (!source.getAttribute('srcset')) {
        source.setAttribute('srcset', source.dataset.srcset);
      }
    });

    root.querySelectorAll('video[data-src]').forEach((video) => {
      if (!video.getAttribute('src')) {
        video.setAttribute('src', video.dataset.src);
      }
    });
  }

  function injectScript(url, isModule) {
    return new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = url;
      if (isModule) el.type = 'module';
      el.onload = () => resolve();
      el.onerror = () => reject(new Error(url));
      document.head.appendChild(el);
    });
  }

  function withImmediateAlpineInit(fn) {
    if (!window.Alpine) return Promise.resolve(fn());

    const original = Document.prototype.addEventListener;
    Document.prototype.addEventListener = function (type, listener, options) {
      if (type === 'alpine:init' && typeof listener === 'function') {
        listener.call(this);
        return;
      }
      return original.call(this, type, listener, options);
    };

    return Promise.resolve()
      .then(fn)
      .finally(() => {
        Document.prototype.addEventListener = original;
      });
  }

  function findScrollingBordersSection(doc) {
    return (
      doc.querySelector('#shopify-section-sv-scrolling-borders') ||
      doc.querySelector('[id^="shopify-section-"][id*="sv-scrolling-borders"]')
    );
  }

  async function applyPageDarkMode(doc) {
    const html = document.documentElement;
    html.classList.remove(
      'sv-page-dark',
      'sv-page-dark-label-override',
      'sv-page-dark-bg-image'
    );

    const existingCritical = document.getElementById('sv-page-dark-critical');
    if (existingCritical) existingCritical.remove();

    const nextCritical = doc.getElementById('sv-page-dark-critical');
    if (!nextCritical) return;

    document.head.appendChild(nextCritical.cloneNode(true));
    html.classList.add('sv-page-dark', 'sv-page-dark-label-override');
    if (
      nextCritical.textContent.includes('--sv-dark-bg-image-desktop') ||
      nextCritical.textContent.includes('--sv-dark-bg-image-mobile')
    ) {
      html.classList.add('sv-page-dark-bg-image');
    }

    const darkCss = doc.querySelector('link[href*="_scroll-borders-dark"]');
    if (darkCss) {
      try {
        const href = new URL(
          darkCss.getAttribute('href'),
          window.location.origin
        ).href;
        await injectStylesheet(href, darkCss.getAttribute('media'));
      } catch (e) {}
    }
  }

  async function swapScrollingBorders(doc) {
    const current = findScrollingBordersSection(document);
    const next = findScrollingBordersSection(doc);

    await applyPageDarkMode(doc);

    function prepareClone(source) {
      const clone = source.cloneNode(true);
      clone.querySelectorAll('script').forEach((s) => s.remove());
      clone.querySelectorAll('#sv-page-dark-critical').forEach((s) => s.remove());
      return clone;
    }

    if (current && next) {
      const clone = prepareClone(next);
      current.replaceWith(clone);
      await promoteBodyStylesheets(clone);
      return clone;
    }

    if (current && !next) {
      current.remove();
      return null;
    }

    if (!current && next) {
      const clone = prepareClone(next);
      const badges = document.querySelector(
        '#shopify-section-sv-product-tags-badges-1, [id*="sv-product-tags-badges"]'
      );
      if (badges && badges.parentNode) {
        badges.parentNode.insertBefore(clone, badges.nextSibling);
      } else {
        document.body.insertBefore(clone, document.body.firstChild);
      }
      await promoteBodyStylesheets(clone);
      return clone;
    }

    return null;
  }

  async function ensureScriptsFrom(doc) {
    const nodes = [
      ...doc.querySelectorAll('#MainContent script[src]'),
      ...doc.querySelectorAll('#heroGroupWrapper script[src]'),
      ...doc.querySelectorAll('.shopify-section-group-footer-group script[src]'),
    ];

    const toLoad = [];
    for (const s of nodes) {
      let url;
      try {
        url = new URL(s.getAttribute('src'), window.location.origin).href;
      } catch (e) {
        continue;
      }
      if (loadedScriptSrcs.has(url)) continue;
      loadedScriptSrcs.add(url);
      toLoad.push({
        url,
        module: s.getAttribute('type') === 'module',
      });
    }

    if (!toLoad.length) return;

    await withImmediateAlpineInit(async () => {
      for (const item of toLoad) {
        try {
          await injectScript(item.url, item.module);
        } catch (e) {
          window.debugLog('[sv-persist-nav] script failed', item.url, e);
        }
      }
    });
  }

  function refreshAlpineTree() {
    const roots = [
      document.querySelector('#MainContent'),
      document.querySelector('#heroGroupWrapper'),
      findFooter(document),
    ].filter(Boolean);

    for (const el of roots) {
      destroyAlpine(el);
      initAlpine(el);
      if (typeof window.discoverNewSlideshows === 'function') {
        window.discoverNewSlideshows(el);
      }
    }
  }

  async function refreshAssets() {
    const roots = [
      document.querySelector('#MainContent'),
      document.querySelector('#heroGroupWrapper'),
      findFooter(document),
    ].filter(Boolean);

    await Promise.all(roots.map((el) => promoteBodyStylesheets(el)));
    roots.forEach((el) => refreshMedia(el));

    roots.forEach((el) => {
      document.dispatchEvent(
        new CustomEvent('switch:load:images', { detail: { container: el } })
      );
    });
  }

  function closeMenuDrawer() {
    if (!window.Alpine || typeof Alpine.store !== 'function') return;
    const modals = Alpine.store('modals');
    if (modals && typeof modals.close === 'function') {
      modals.close('menu-drawer');
    }
  }

  async function navigate(url, { replace = false } = {}) {
    if (inFlight) return;
    inFlight = true;
    closeMenuDrawer();

    try {
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });

      if (!res.ok) {
        window.location.href = url;
        return;
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (!doc.querySelector('#MainContent')) {
        window.location.href = url;
        return;
      }

      const title = doc.querySelector('title');
      if (title) document.title = title.textContent;

      await adoptHeadStyles(doc);
      await ensureScriptsFrom(doc);

      await swapScrollingBorders(doc);

      swapHero(doc);
      if (!swapMain(doc)) {
        window.location.href = url;
        return;
      }
      swapFooter(doc);
      swapSidebarLogo(doc);

      await refreshAssets();
      await syncLenisForPage();
      resetScroll();
      refreshAlpineTree();

      if (replace) {
        history.replaceState({ svPersistNav: true }, '', url);
      } else {
        history.pushState({ svPersistNav: true }, '', url);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (typeof window.initScrollingBorders === 'function') {
            window.initScrollingBorders();
          }
          document.dispatchEvent(
            new CustomEvent('sv:persist-nav', { detail: { url: String(url) } })
          );
        });
      });
    } catch (e) {
      window.debugLog('[sv-persist-nav]', e);
      window.location.href = url;
    } finally {
      inFlight = false;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (!shouldIntercept(anchor, event)) return;

      event.preventDefault();
      navigate(new URL(anchor.href, window.location.origin));
    },
    true
  );

  window.addEventListener('popstate', () => {
    if (isDesignMode()) return;
    navigate(new URL(window.location.href), { replace: true });
  });
})();
